import { getUtmFields } from "lib/helpers"
import { useRouter } from "next/router"

function MarketingFieldsInput() {
  const { query } = useRouter()

  return getUtmFields(query).map(
    field =>
      field.value && (
        <input
          key={field.field}
          name={field.field}
          value={field.value}
          type="hidden"
        />
      )
  )
}

export default MarketingFieldsInput
